module.exports = __webpack_public_path__ + "img/popop_red_18.703d31bb.png";